import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import {Link, useParams} from "react-router-dom";
import styled from "styled-components";
import { getAboutUsLastTitle } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import CustomTable from "../../Common/DataTable/DataTable";

export default function TitleView() {
  const {id, partnerId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [title, setTitle] = useState();

  const fetchTitle = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }
    try {
      const res = await getAboutUsLastTitle(id);
      const bottomData = res.data.data[0];
      setTitle({...title, ...bottomData, index: res.data.data.indexOf(bottomData)});
    } catch (error) {
      showToast({
        type: 'error',
        message: error.response.data.message || 'Failed to fetch title data. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTitle();
  }, [id]);

  const columns = ["Part Name", "Content"];
  const rows = [];

  if (title) {
    rows.push(["Title", title.tittle]);
  }

  return (
    <>
    {isLoading ? <CmsCircularProgress/> : 
    <ContentWrapper>
      {/* Title */}
      <HomeTitle>Bottom Section</HomeTitle>
      {/* Table */}

      <CustomTable columns={columns} rows={rows}/>
      {/* Button section */}
      <ButtonWrapper>
        <Link
          to={`/${partnerId}/aboutus`}
        >
          <Button variant="secondary">Go Back</Button>
        </Link>
        <Link
          to={`/${partnerId}/aboutus/bottom_title/edit/${id}`}
        >
          <Button>Edit</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>}
    </>
  );
}

const ContentWrapper = styled.div`
  @media (min-width:576px) {
    padding: 1rem;
    }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;



const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 2rem;
  justify-content: center;
   @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
  gap: 1rem;
  }
`;
